<template>
  <div class="header">
    <span class="page-name">
      <span class="page-name__xiv">XIV</span>
      <span class="page-name__divider"></span>
      <span class="page-name__status">Status</span>
    </span>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" type="text/scss" scoped>
.header {
  position: fixed;
  z-index: 3;
  display: flex;
  align-items: center;
  height: em(64px);
  width: 100%;
  padding-left: em(20px);
  background-color: $color-dark-1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.page-name {
  display: flex;
  color: $color-white;
  font-family: $font-roboto-slab;
}

.page-name__xiv {
  font-weight: 700;
  font-size: em(21px);
}

.page-name__divider {
  width: em(1px);
  background-color: rgba(255, 255, 255, 0.4);
  margin: 0 em(5px);
}

.page-name__status {
  font-weight: 300;
  font-size: em(21px);
}
</style>